// src/ar.ts
var ar = {
  app: {
    name: "\u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0646\u062C\u0627\u062D",
    tagline: "\u0646\u0638\u0627\u0645 \u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 \u0648\u0627\u0644\u0642\u0631\u0637\u0627\u0633\u064A\u0629",
    shortName: "\u0627\u0644\u0646\u062C\u0627\u062D"
  },
  common: {
    save: "\u062D\u0641\u0638",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    delete: "\u062D\u0630\u0641",
    edit: "\u062A\u0639\u062F\u064A\u0644",
    add: "\u0625\u0636\u0627\u0641\u0629",
    search: "\u0628\u062D\u062B",
    filter: "\u062A\u0635\u0641\u064A\u0629",
    close: "\u0625\u063A\u0644\u0627\u0642",
    confirm: "\u062A\u0623\u0643\u064A\u062F",
    back: "\u0631\u062C\u0648\u0639",
    next: "\u0627\u0644\u062A\u0627\u0644\u064A",
    previous: "\u0627\u0644\u0633\u0627\u0628\u0642",
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    noData: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
    noResults: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0645\u0637\u0627\u0628\u0642\u0629",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
    required: "\u0645\u0637\u0644\u0648\u0628",
    optional: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A",
    yes: "\u0646\u0639\u0645",
    no: "\u0644\u0627",
    all: "\u0627\u0644\u0643\u0644",
    total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639",
    print: "\u0637\u0628\u0627\u0639\u0629",
    export: "\u062A\u0635\u062F\u064A\u0631",
    refresh: "\u062A\u062D\u062F\u064A\u062B",
    actions: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
    status: "\u0627\u0644\u062D\u0627\u0644\u0629",
    date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
    from: "\u0645\u0646",
    to: "\u0625\u0644\u0649"
  },
  auth: {
    login: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    logout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    username: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
    password: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    usernamePlaceholder: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
    passwordPlaceholder: "\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    rememberMe: "\u062A\u0630\u0643\u0651\u0631\u0646\u064A \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
    signingIn: "\u062C\u0627\u0631\u064D \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\u2026",
    welcomeBack: "\u0623\u0647\u0644\u0627\u064B \u0628\u0639\u0648\u062F\u062A\u0643",
    loginSubtitle: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
    invalidCredentials: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0623\u0648 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
    accountDisabled: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u0639\u0637\u0651\u0644 \u2014 \u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    sessionExpired: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u062C\u0644\u0633\u0629\u060C \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F",
    changePassword: "\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    currentPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
    newPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
    confirmPassword: "\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    unauthorized: "\u0644\u0627 \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629"
  },
  nav: {
    dashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
    pos: "\u0646\u0642\u0637\u0629 \u0627\u0644\u0628\u064A\u0639",
    products: "\u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A",
    categories: "\u0627\u0644\u062A\u0635\u0646\u064A\u0641\u0627\u062A",
    inventory: "\u0627\u0644\u0645\u062E\u0632\u0648\u0646",
    stockMovements: "\u062D\u0631\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u0632\u0648\u0646",
    stockTake: "\u0627\u0644\u062C\u0631\u062F",
    orders: "\u0627\u0644\u0637\u0644\u0628\u0627\u062A",
    deliveries: "\u0627\u0644\u062A\u0648\u0635\u064A\u0644",
    purchases: "\u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A",
    suppliers: "\u0627\u0644\u0645\u0648\u0631\u062F\u0648\u0646",
    expenses: "\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
    customers: "\u0627\u0644\u0632\u0628\u0627\u0626\u0646",
    debts: "\u0627\u0644\u062F\u064A\u0648\u0646",
    sales: "\u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A",
    reports: "\u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631",
    settings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    users: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646",
    branches: "\u0627\u0644\u0641\u0631\u0648\u0639 \u0648\u0627\u0644\u0635\u0646\u0627\u062F\u064A\u0642",
    stockTakes: "\u0627\u0644\u062C\u0631\u062F",
    roles: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
    stores: "\u0627\u0644\u0641\u0631\u0648\u0639",
    profile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A"
  },
  dashboard: {
    title: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
    todaySales: "\u0645\u0628\u064A\u0639\u0627\u062A \u0627\u0644\u064A\u0648\u0645",
    todayProfit: "\u0631\u0628\u062D \u0627\u0644\u064A\u0648\u0645",
    invoiceCount: "\u0639\u062F\u062F \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
    pendingOrders: "\u0637\u0644\u0628\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
    lowStock: "\u0645\u0646\u062A\u062C\u0627\u062A \u0639\u0644\u0649 \u0648\u0634\u0643 \u0627\u0644\u0646\u0641\u0627\u062F",
    outOfStock: "\u0645\u0646\u062A\u062C\u0627\u062A \u0646\u0641\u062F\u062A",
    outstandingDebts: "\u062F\u064A\u0648\u0646 \u0645\u0633\u062A\u062D\u0642\u0629",
    topProducts: "\u0627\u0644\u0623\u0643\u062B\u0631 \u0645\u0628\u064A\u0639\u0627\u064B",
    recentSales: "\u0622\u062E\u0631 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A",
    weeklyChart: "\u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A \u062E\u0644\u0627\u0644 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
    comingSoon: "\u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0642\u064A\u062F \u0627\u0644\u062A\u0637\u0648\u064A\u0631"
  },
  sync: {
    online: "\u0645\u062A\u0635\u0644",
    offline: "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644",
    syncing: "\u062C\u0627\u0631\u064D \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629\u2026",
    synced: "\u062A\u0645\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629",
    pending: (n) => `${n} \u0639\u0645\u0644\u064A\u0629 \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629`,
    lastSync: "\u0622\u062E\u0631 \u0645\u0632\u0627\u0645\u0646\u0629",
    syncNow: "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0622\u0646",
    syncFailed: "\u0641\u0634\u0644\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629",
    offlineNotice: "\u0623\u0646\u062A \u062A\u0639\u0645\u0644 \u062F\u0648\u0646 \u0627\u062A\u0635\u0627\u0644 \u2014 \u0633\u064A\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0648\u0645\u0632\u0627\u0645\u0646\u062A\u0647\u0627 \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u0639\u0646\u062F \u0639\u0648\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644"
  },
  errors: {
    network: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645 \u2014 \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0634\u0628\u0643\u0629",
    server: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062E\u0627\u062F\u0645\u060C \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627\u064B",
    notFound: "\u0627\u0644\u0635\u0641\u062D\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
    notFoundDesc: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0637\u0644\u0628\u062A\u0647 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u062A\u0645 \u0646\u0642\u0644\u0647",
    unknown: "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639",
    validation: "\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u064F\u062F\u062E\u0644\u0629",
    goHome: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645"
  },
  theme: {
    light: "\u0641\u0627\u062A\u062D",
    dark: "\u062F\u0627\u0643\u0646",
    system: "\u062D\u0633\u0628 \u0627\u0644\u0646\u0638\u0627\u0645",
    toggle: "\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0645\u0638\u0647\u0631"
  }
};

// src/index.ts
var DEFAULT_LOCALE = "ar";
var LOCALE_DIR = { ar: "rtl" };
var dictionaries = { ar };
function getMessages(locale = DEFAULT_LOCALE) {
  return dictionaries[locale];
}
var t = ar;
export {
  DEFAULT_LOCALE,
  LOCALE_DIR,
  ar,
  getMessages,
  t
};
//# sourceMappingURL=index.js.map